export default "__VITE_ASSET__95cbf2a2__"